import React, { useState, useEffect } from "react";
import '../../App.css'
import Kategori from '../Kategori'
import '../Kategori.css'
import dostlukPekiştirenler from '../../assets/menu/sandivic-3.png'
import gözlemeler from '../../assets/menu/Mrs.Boss-Cafe.png'
import hamburgerler from '../../assets/menu/ana-yemek-1.png'
import makarnalar from '../../assets/menu/ana-yemek-2.png'
import beef from '../../assets/beef.png'
import tostlar from '../../assets/menu/tostlar.jpeg'
import wraplar from '../../assets/menu/yemekler/wraplar/kofte-wrap.jpg'

const Yemekler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  return (
    isPhone ? (
    <div>
    <div className="container">
      <img src={beef} style={{width: '36px', height: '36px'}} alt="Beefi" />
      <h2 style={{marginLeft: 'auto', fontWeight: '700' }}>Yemekler</h2>
      
    </div>
    <hr style={{color: '#D8D8D8'}} />
    <div className="kategoriler-list">
        <Kategori ad="Dostluk Pekiştirenler" resim={dostlukPekiştirenler} />
        <Kategori ad="Gözlemeler" resim={gözlemeler} />
        <Kategori ad="Hamburgerler" resim={hamburgerler} />
        <Kategori ad="Makarnalar" resim={makarnalar} />   
        <Kategori ad="Tostlar" resim={tostlar} />   
        <Kategori ad="Wraplar" resim={wraplar} />
      </div>
    </div>
  ) : (
    <div>
    <div className="container">
      <img src={beef} style={{width: '36px', height: '36px'}} alt="Beefi" />
      <h2 style={{marginLeft: 'auto', fontWeight: '700' }}>Yemekler</h2>
      
    </div>
    <hr style={{color: '#D8D8D8'}} />
    <div className="kategoriler-list-computer">
        <Kategori ad="Dostluk Pekiştirenler" resim={dostlukPekiştirenler} />
        <Kategori ad="Gözlemeler" resim={gözlemeler} />
        <Kategori ad="Hamburgerler" resim={hamburgerler} />
        <Kategori ad="Makarnalar" resim={makarnalar} />   
        <Kategori ad="Tostlar" resim={tostlar} />  
        <Kategori ad="Wraplar" resim={wraplar} />
    </div>
    </div>
  )
  )
}

export default Yemekler
